/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { AppBarNotification } from '@veeam-vspc/components';

import { useAppBellStore } from '../../hooks';
import { useLang } from '../../../../providers/LangProvider/hooks';
import { NotificationBellMessage } from '../NotificationBellMessage';

export const Bell: React.FC = observer(() => {
    const lang = useLang();
    const bellStore = useAppBellStore();

    useEffect(() => {
        bellStore.connect();

        return bellStore.subscribeToEvents();
    }, []);

    return (
        <AppBarNotification
            isAutoDisplay={false}
            noAutoDisplay={true}
            unread={bellStore.unread}
            messages={bellStore.messages.map(({ permanentNotificationPayload, asyncActionPayload, ...props }) => ({
                render: () => <NotificationBellMessage {...props} />,
            }))}
            texts={{
                empty: lang.NO_NOTIFICATIONS,
                clearAll: lang.CLEAR_ALL,
            }}
        />
    );
});
